import { Link, useParams } from "react-router-dom";

const terms = `
TERMENI ȘI CONDIȚII STOCK MUSIC RO SRL — versiunea 1.0

1. Obiectul serviciului
StockMusicRo oferă acces la un catalog muzical virtual pentru utilizare ambientală în spații comerciale, conform licenței neexclusive emise pentru client.

2. Contul clientului
Clientul declară că informațiile introduse la înregistrare sunt complete, actuale și reale sub rezerva Art. 326 din NCP privind Falsul în declarații. Clientul este responsabil pentru păstrarea confidențialității datelor de autentificare.

3. Licența
O licență se va emite pentru fiecare punct de lucru unde se difuzează muzică. De asemenea, licența se va emite pentru fiecare activitate din cadrul aceluiași punct de lucru cu suprafață determinată în metri pătrați, cât și pentru o perioadă de licențiere selectată de client (festival de o zi, activitate sezonieră de o lună, activitate permanentă trimestrială, semestrială sau anuală). Licența nu poate fi transferată unei alte persoane fizice, persoane juridice sau unui alt punct de lucru fără acordul StockMusicRo.

4. Plata prin transfer bancar
După solicitarea licenței, clientul primește datele de plată și o referință unică. Accesul complet la catalog, contractul completat și licența PDF devin disponibile doar după confirmarea plății în contul bancar al StockMusicRo.

5. Documente electronice
Clientul acceptă ca documentele contractuale, licențele, facturile și notificările aferente serviciului să fie transmise în format electronic.

6. Utilizarea catalogului
Clientul poate utiliza catalogul numai în limitele licenței active. După expirarea, suspendarea sau revocarea licenței, clientul trebuie să își reînnoiască licențele sau să oprească utilizarea catalogului muzical.

7. Modificări
StockMusicRo poate actualiza acești termeni. Utilizatorii vor fi informați în platformă atunci când este necesară acceptarea unei versiuni noi.

8. Contact
Pentru întrebări juridice sau comerciale, e-mail către: licente@stockmusic.ro și vă vom răspunde în cel mai scurt timp posibil.
`;

const privacy = `
POLITICA DE CONFIDENȚIALITATE ȘI PRELUCRAREA DATELOR CU CARACTER PERSONAL — versiunea 1.0

1. Operatorul de date
Datele sunt prelucrate de STOCK MUSIC RO SRL, în calitate de operator de date. Contact: licente@stockmusic.ro.

2. Date colectate
Putem colecta: nume și prenume, denumire firmă, CUI, nr. Registrul Comerțului, adresă sediu și punct de lucru, email, telefon, activitate, suprafață, informații despre licențe, plăți, documente emise, IP și date tehnice necesare securității platformei.

3. Scopuri
Datele sunt prelucrate pentru creare cont, emitere contract/licență/factură, furnizare acces la catalog, comunicări operaționale, respectarea obligațiilor legale, evidență contabilă, prevenirea fraudelor și securizarea platformei.

4. Temei legal
Prelucrarea se bazează pe executarea contractului, obligații legale, consimțământul exprimat de utilizator și interesul legitim privind securitatea serviciului.

5. Stocare
Datele sunt păstrate cât timp este necesar pentru executarea contractului și ulterior conform obligațiilor legale fiscale și contabile.

6. Drepturile utilizatorului
Utilizatorul are drept de acces, rectificare, ștergere, restricționare, portabilitate, opoziție și dreptul de a depune plângere la ANSPDCP.

7. Securitate
StockMusic aplică măsuri tehnice și organizatorice rezonabile pentru protejarea datelor împotriva accesului neautorizat, pierderii sau modificării.

8. Documente electronice și dovada consimțământului
La înregistrare se salvează data, IP-ul și versiunea documentelor acceptate, pentru a dovedi acordul exprimat online.

9. Contact
Pentru solicitări GDPR: licente@stockmusic.ro.
`;

export default function Legal() {
  const { type } = useParams();
  const isPrivacy = type === "privacy" || type === "gdpr";
  return (
    <div className="mx-auto max-w-4xl px-4 pb-32 pt-10 sm:px-6 lg:px-8">
      <Link to="/register" className="text-sm text-[#D4A23A] hover:underline">← Înapoi la înregistrare</Link>
      <div className="mt-6 rounded-3xl border border-white/5 bg-[#121212] p-6 sm:p-8">
        <p className="text-xs uppercase tracking-[0.3em] text-[#D4A23A]">StockMusic legal</p>
        <h1 className="mt-2 font-display text-3xl font-black tracking-tight sm:text-4xl">
          {isPrivacy ? "Politica de Confidențialitate / GDPR" : "Termeni și Condiții"}
        </h1>
        <pre className="mt-6 whitespace-pre-wrap font-sans text-sm leading-7 text-zinc-300">{isPrivacy ? privacy : terms}</pre>
      </div>
    </div>
  );
}
